// export default {
//   login: 'john-smilga',
//   id: 42133389,
//   node_id: 'MDQ6VXNlcjQyMTMzMzg5',
//   avatar_url: 'https://avatars3.githubusercontent.com/u/42133389?v=4',
//   gravatar_id: '',
//   url: 'https://api.github.com/users/john-smilga',
//   html_url: 'https://github.com/john-smilga',
//   followers_url: 'https://api.github.com/users/john-smilga/followers',
//   following_url:
//     'https://api.github.com/users/john-smilga/following{/other_user}',
//   gists_url: 'https://api.github.com/users/john-smilga/gists{/gist_id}',
//   starred_url:
//     'https://api.github.com/users/john-smilga/starred{/owner}{/repo}',
//   subscriptions_url: 'https://api.github.com/users/john-smilga/subscriptions',
//   organizations_url: 'https://api.github.com/users/john-smilga/orgs',
//   repos_url: 'https://api.github.com/users/john-smilga/repos',
//   events_url: 'https://api.github.com/users/john-smilga/events{/privacy}',
//   received_events_url:
//     'https://api.github.com/users/john-smilga/received_events',
//   type: 'User',
//   site_admin: false,
//   name: 'John Smilga',
//   company: 'Coding Addict',
//   blog: 'www.johnsmilga.com',
//   location: 'Los Angeles',
//   email: null,
//   hireable: null,
//   bio: 'Creator of Coding Addict',
//   twitter_username: 'john_smilga',
//   public_repos: 152,
//   public_gists: 0,
//   followers: 1495,
//   following: 0,
//   created_at: '2018-08-06T06:48:23Z',
//   updated_at: '2020-07-08T05:01:32Z',
// };


export default {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false,
"name": "Microsoft",
"company": null,
"blog": "https://opensource.microsoft.com",
"location": "Redmond, WA",
"email": "opensource@microsoft.com",
"hireable": null,
"bio": "Open source projects and samples from Microsoft",
"twitter_username": "OpenAtMicrosoft",
"public_repos": 4259,
"public_gists": 0,
"followers": 0,
"following": 0,
"created_at": "2013-12-10T19:06:48Z",
"updated_at": "2021-03-18T18:50:55Z"
}